// @ts-check

import {
  isArray,
  isEmpty,
  isFunction,
  isNil,
  isObject,
  isString,
} from "lodash";

/**
 * Returns true if the value is:
 * - A function.
 * - A non empty object/array/string.
 * - A non nil value.
 * @param {any} v
 * @returns {boolean}
 */
export const isPopulated = (v) => {
  if (isFunction(v)) {
    return true;
  }
  if (isObject(v) || isArray(v) || isString(v)) {
    return !isEmpty(v);
  }
  return !isNil(v);
};

/**
 * Returns the first value that is populated @see isPopulated
 *
 * @template T
 * @param {...T} values - Values to check.
 * @returns {T | undefined}
 */
export const firstPopulated = (...values) => {
  return values.find(isPopulated);
};
